export const FieldIdLabels = {
  CONTACT_FIRST_NAME: "Contact First Name",
  CONTACT_LAST_NAME: "Contact Last Name",
  CONTACT_EMAIL: "Contact Email",
  CONTACT_PHONE: "Contact Phone",
  CONVERSATION_CONNECTION_TYPE: "Connection Type",
};
